var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoalWorkspace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 152,
    height: 152,
    viewBox: "0 0 152 152",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9577_28766)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M113 1H39C18.0132 1 1 18.0132 1 39V113C1 133.987 18.0132 151 39 151H113C133.987 151 151 133.987 151 113V39C151 18.0132 133.987 1 113 1Z",
    fill: "#CurrentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113 1H39C18.0132 1 1 18.0132 1 39V113C1 133.987 18.0132 151 39 151H113C133.987 151 151 133.987 151 113V39C151 18.0132 133.987 1 113 1Z",
    stroke: "url(#paint0_linear_9577_28766)",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_9577_28766)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M99.5052 43.9982H52.5067C51.4012 43.9982 50.5083 44.8911 50.5083 45.9966V72.1178C50.5083 73.2234 51.4012 74.1162 52.5067 74.1162H99.491C100.596 74.1162 101.489 73.2234 101.489 72.1178V45.9966C101.504 44.9053 100.596 43.9982 99.5052 43.9982Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.5074 40H52.5089C49.2066 40 46.5137 42.6929 46.5137 45.9953V72.1165C46.5137 75.4189 49.2066 78.1118 52.5089 78.1118H99.4932C102.796 78.1118 105.489 75.4189 105.489 72.1165V45.9953C105.503 42.6929 102.81 40 99.5074 40ZM101.506 72.1165C101.506 73.222 100.613 74.115 99.5074 74.115H52.5089C51.4034 74.115 50.5105 73.222 50.5105 72.1165V45.9953C50.5105 44.8898 51.4034 43.9969 52.5089 43.9969H99.4932C100.599 43.9969 101.492 44.8898 101.492 45.9953V72.1165H101.506Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.4958 47.9933H56.5194C55.4139 47.9933 54.521 48.8862 54.521 49.9917V53.2799H61.9336C63.0391 53.2799 63.932 54.1729 63.932 55.2783C63.932 56.3838 63.0391 57.2768 61.9336 57.2768H54.521V60.8342H58.1493C59.2548 60.8342 60.1478 61.7272 60.1478 62.8327C60.1478 63.9382 59.2548 64.8311 58.1493 64.8311H54.5068V68.1193C54.5068 69.2248 55.3998 70.1177 56.5052 70.1177H95.4958C96.6013 70.1177 97.4942 69.2248 97.4942 68.1193V50.0059C97.5084 48.9004 96.6013 47.9933 95.4958 47.9933Z",
    fill: "#CurrentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.0823 91.6325C62.7122 91.6325 64.0304 90.3144 64.0304 88.6845C64.0304 87.0546 62.698 85.7223 61.0823 85.7223C59.4665 85.7223 58.1343 87.0546 58.1343 88.6845C58.1343 90.3144 59.4524 91.6325 61.0823 91.6325Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.2086 101.511L62.8275 105.72C62.0622 107.08 60.1063 107.08 59.3409 105.72L56.9598 101.511C54.3661 102.772 52.4669 105.196 51.8574 108.002H70.311C69.7015 105.182 67.8023 102.772 65.2086 101.511Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.085 101.511L92.7039 105.734C91.9386 107.095 89.9827 107.095 89.2173 105.734L86.8362 101.511C84.2425 102.772 82.3433 105.196 81.7339 108.002H100.187C99.5638 105.182 97.6787 102.772 95.085 101.511Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.0412 88.6704C68.0412 84.8294 64.923 81.7113 61.0821 81.7113C57.2412 81.7113 54.123 84.8294 54.123 88.6704C54.123 92.5113 57.2412 95.6294 61.0821 95.6294C64.923 95.6294 68.0412 92.5113 68.0412 88.6704ZM61.0821 85.7224C62.7121 85.7224 64.0302 87.0546 64.0302 88.6845C64.0302 90.3145 62.6979 91.6326 61.0821 91.6326C59.4664 91.6326 58.1341 90.3145 58.1341 88.6845C58.1341 87.0546 59.4522 85.7224 61.0821 85.7224Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.867 97.1041C63.974 96.8349 63.0102 97.2317 62.5567 98.0396L61.0827 100.676L59.6087 98.0396C59.1551 97.2317 58.1913 96.8349 57.2985 97.1041C51.615 98.7766 47.6323 104.077 47.6323 110.002C47.6323 111.108 48.5252 112.001 49.6307 112.001H72.5205C73.626 112.001 74.5189 111.108 74.5189 110.002C74.5331 104.077 70.5646 98.7766 64.867 97.1041ZM51.8559 108.003C52.4796 105.197 54.3646 102.773 56.9583 101.512L59.3394 105.736C60.1048 107.097 62.0607 107.097 62.826 105.736L65.2071 101.512C67.8008 102.773 69.7 105.197 70.3094 108.003H51.8559Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.7444 97.1041C93.8515 96.8349 92.8877 97.2317 92.4342 98.0396L90.9601 100.676L89.472 98.0396C89.0184 97.2317 88.0546 96.8349 87.1617 97.1041C81.4783 98.7766 77.4956 104.077 77.4956 110.002C77.4956 111.108 78.3885 112.001 79.494 112.001H102.384C103.489 112.001 104.382 111.108 104.382 110.002C104.411 104.077 100.428 98.7766 94.7444 97.1041ZM81.7334 108.003C82.357 105.197 84.242 102.773 86.8357 101.512L89.2168 105.736C89.9822 107.097 91.9381 107.097 92.7034 105.736L95.0846 101.512C97.6783 102.773 99.5775 105.197 100.187 108.003H81.7334Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.8888 88.6704C97.8888 84.8294 94.7707 81.7113 90.9298 81.7113C87.0888 81.7113 83.9707 84.8294 83.9707 88.6704C83.9707 92.5113 87.0888 95.6294 90.9298 95.6294C94.7707 95.6294 97.8888 92.5113 97.8888 88.6704ZM87.9676 88.6704C87.9676 87.0404 89.2999 85.7082 90.9298 85.7082C92.5597 85.7082 93.8778 87.0404 93.8778 88.6704C93.8778 90.3002 92.5597 91.6184 90.9298 91.6184C89.2999 91.6184 87.9676 90.3002 87.9676 88.6704Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_9577_28766",
    x: 46.5137,
    y: 40,
    width: 58.9751,
    height: 76.0007,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_9577_28766"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9577_28766",
    x1: 76,
    y1: 1,
    x2: 76,
    y2: 151,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9577_28766"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 152,
    height: 152,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoalWorkspace);
export default __webpack_public_path__ + "static/media/Goal-Workspace.5f278878e9a36ff859091a5e3a813b67.svg";
export { ForwardRef as ReactComponent };